const STATE_ORDER = ['ACTIVE', 'DRAFT', 'COMPLETED'];

export const normalizeSprintState = (sprint) => {
  const state = String(sprint?.state || sprint?.status || 'DRAFT').toUpperCase();
  if (state === 'PLANNED' || state === 'UPCOMING') return 'DRAFT';
  if (state === 'CLOSED' || state === 'DONE') return 'COMPLETED';
  if (state === 'CURRENT') return 'ACTIVE';
  return state;
};

export const groupScrumSprintsByState = (sprints = []) => {
  const groupsByState = sprints.reduce((groups, sprint) => {
    if (sprint?.id === undefined || sprint?.id === null) return groups;
    const state = normalizeSprintState(sprint);
    if (!groups[state]) groups[state] = [];
    groups[state].push(sprint);
    return groups;
  }, {});

  return Object.entries(groupsByState)
    .map(([state, groupedSprints]) => ({
      state,
      sprints: groupedSprints,
      value: groupedSprints.map((sprint) => sprint.id).join(',')
    }))
    .sort((left, right) => {
      const leftIndex = STATE_ORDER.indexOf(left.state);
      const rightIndex = STATE_ORDER.indexOf(right.state);
      return (leftIndex === -1 ? STATE_ORDER.length : leftIndex)
        - (rightIndex === -1 ? STATE_ORDER.length : rightIndex);
    });
};

/** Returns true when id is a non-null, non-empty string. */
export const validSprintId = (id) => id != null && String(id).trim() !== '';

/**
 * Normalises any sprint value representation to a clean string[] of valid IDs.
 * Handles: undefined, "all", "1,2,3", ["all"], ["1","2"], [null, ""], mixed arrays.
 * Returns [] when the effective selection is "all" / empty.
 */
export const normalizeSprintIds = (value, ALL = 'all') => {
  if (!value) return [];
  const ids = Array.isArray(value) ? value : String(value).split(',');
  return ids
    .filter(validSprintId)
    .map((v) => String(v).trim())
    .filter(validSprintId)
    .filter((v) => v !== ALL);
};
